import { Builder } from '@builder.io/react';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';
import { S36StaffSection } from '../components/interactive-sections/S36Staff';
import { getBackgroundColorInput, getPaddingInputs } from '../utils/builderSharedInputs';
import { altBackgroundColorOptions } from '../utils/builderColorOptions';

Builder.registerComponent(S36StaffSection, {
  name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S36Staff,
  friendlyName: 'S36 Staff',
  inputs: [
    ...getBackgroundColorInput({
      defaultValue: 'Turquoise20',
      backgroundColorsList: altBackgroundColorOptions,
    }),
    ...getPaddingInputs()
  ]
}); 